export const SET_TOKEN   = 'SET_TOKEN'

export const setToken = (token) => ({
  type: SET_TOKEN,
  payload: { token }
})

// TODO: eventually call and get token using the store instead of App.js maybe?